// import Chart from 'chart.js/auto';
import $ from "jquery";

function updateModalImage(element) {
    // 1. Buscas la URL y la asignas
    let modalImg = document.getElementById('modalImage');
    const fullImageUrl = element.getAttribute('data-bs-remote');
    modalImg.src = fullImageUrl;

    // 2. ABRES EL MODAL USANDO JQUERY
    // Esto funciona tanto en Bootstrap 4 como en 5 si jQuery está cargado
    $('#photoModal').modal('show');
}

function destroyCustomerIndex() {
    if(document.getElementById('customer-index')) {

    }
}

function setupCustomerIndex() {
    if(document.getElementById('customer-index')) {

    }
}

document.addEventListener("turbolinks:load", setupCustomerIndex);
document.addEventListener('turbolinks:before-cache', destroyCustomerIndex);

window.updateModalImage = updateModalImage;

// Rails 7 & Hotwire/Turbo
// document.addEventListener('turbo:load', setupUserForm);
// document.addEventListener('turbo:before-cache', teardownUserForm);